/* eslint-disable @typescript-eslint/no-explicit-any */
import { UserOnboardingState } from '51trips-frontend-core'

const userOnboardingStateConverter = {
  toFirestore: (userOnboardingState: UserOnboardingState) => {
    return {
      completedVisitedPlaces: userOnboardingState.completedVisitedPlaces
    }
  },
  fromFirestore: (data: any) => {
    if (typeof data.completedVisitedPlaces === 'boolean') {
      const completedVisitedPlaces = data.completedVisitedPlaces
      return new UserOnboardingState(completedVisitedPlaces)
    } else {
      return undefined
    }
  }
}

export default userOnboardingStateConverter
